<template>
  <div class="min-h-screen bg-zinc-900 flex items-center justify-center p-1 sm:p-4 font-nunito">
    <!-- Container principal -->
    <div class="w-full max-w-lg">
      <!-- Logo -->
      <div class="flex items-center justify-center mb-8">
        <img src="@/assets/bot_express_logo.png" alt="Logo" class="h-auto w-[180px] sm:w-[280px]">
      </div>

      <!-- Card de login -->
      <div class="bg-white/5 rounded-xl overflow-hidden">
        <div class="p-6 sm:p-8">
          <!-- Cabeçalho -->
          <div class="mb-8">
            <h2 class="text-white text-2xl font-bold mb-2">Recuperar Senha</h2>
            <p class="text-[#888888]">Digite seu email para enviarmos o link de redefinição de senha</p>
          </div>

          <!-- Formulário -->
          <form @submit.prevent="handleSendPasswordResetLink" class="space-y-5">
            <!-- Email -->
            <div class="space-y-2">
              <label for="email" class="block text-sm font-medium text-[#AAAAAA]">Email</label>
              <div class="relative">
                <input 
                  id="email" 
                  v-model="email" 
                  type="email" 
                  required
                  class="w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-[#555555] focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200"
                  placeholder="seu@email.com"
                />
                <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-[#555555]">
                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                  </svg>
                </div>
              </div>
            </div>

            <!-- Botão de login -->
            <button 
              type="submit" 
              class="w-full py-3 px-4 bg-[#10B981] hover:bg-[#0EA271] text-white font-medium rounded-md transition-colors duration-200 flex items-center justify-center"
              :disabled="!email || isLoading"
              :class="{
                'opacity-50 cursor-not-allowed pointer-events-none': !email || isLoading
              }"
            >
              <Loader2 v-if="isLoading" class="w-4 h-4 animate-spin mr-2" />
              <span>Enviar</span>
            </button>
          </form>

          <!-- Link para criar conta -->
          <div class="mt-8 text-center">
            <p class="text-[#888888] text-sm">
              Lembrou sua senha?
              <RouterLink to="/login" class="text-[#10B981] hover:text-[#0EA271] font-medium ml-1 transition-colors">
                Voltar ao login
              </RouterLink>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Toaster />
</template>

<script setup lang="ts">
import { toast, Toaster } from '@/components/ui/toast'
import { useAuth } from '@/composables/useAuth'
import { Loader2 } from 'lucide-vue-next'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

// Estado do formulário
const router = useRouter()
const { sendResetPasswordLink } = useAuth()
const email = ref('')
const isLoading = ref(false)

// Função de login
const handleSendPasswordResetLink = async () => {
  isLoading.value = true
  try {
    await sendResetPasswordLink(email.value)

    toast({
      title: 'Email enviado',
      description: 'Verifique seu email para redefinir a senha',
      class: 'bg-green-500 text-white',
      duration: 3000
    })

    email.value = ''
  } catch (error) {
    email.value = ''
  } finally {
    isLoading.value = false
  }
}
</script>